import { useState } from 'react';
import { Select } from '../../design-system/components/Select';
import { Spinner } from '../../design-system/components/Spinner';
import { EmptyState } from '../../shared/components/EmptyState';
import { ErrorState } from '../../shared/components/ErrorState';
import { useAuthStore } from '../auth/store';
import { KnowledgeTable } from './components/KnowledgeTable';
import { UploadZoneWeb } from './components/UploadZoneWeb';
import { useKnowledgeList } from './hooks';
import {
  KNOWLEDGE_DOC_TYPE_OPTIONS,
  KNOWLEDGE_STATUS_OPTIONS,
  type KnowledgeDocType,
  type KnowledgeStatus,
} from './status';

export function KnowledgeBaseWebScreen() {
  const role = useAuthStore((s) => s.user?.role);
  const canAdmin = role === 'admin';
  const [statusFilter, setStatusFilter] = useState<KnowledgeStatus | ''>('');
  const [docTypeFilter, setDocTypeFilter] = useState<KnowledgeDocType | ''>('');

  const query = useKnowledgeList({
    status: statusFilter === '' ? undefined : statusFilter,
    doc_type: docTypeFilter === '' ? undefined : docTypeFilter,
    limit: 50,
  });

  return (
    <div className="dash-section">
      <div className="dash-section__header">
        <h1 className="dash-section__title">Knowledge Base</h1>
      </div>

      {canAdmin ? <UploadZoneWeb /> : null}

      <div className="dash-section__header">
        <Select
          label="Status"
          options={KNOWLEDGE_STATUS_OPTIONS}
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value as KnowledgeStatus | '')}
        />
        <Select
          label="Categoria"
          options={KNOWLEDGE_DOC_TYPE_OPTIONS}
          value={docTypeFilter}
          onChange={(e) => setDocTypeFilter(e.target.value as KnowledgeDocType | '')}
        />
      </div>

      {query.isPending ? (
        <div className="center">
          <Spinner label="Carregando documentos" />
        </div>
      ) : query.isError ? (
        <ErrorState error={query.error} onRetry={() => query.refetch()} />
      ) : query.data.items.length === 0 ? (
        <EmptyState
          title="Nenhum documento"
          description={
            canAdmin
              ? 'Envie PDFs, DOCX, PPTX, TXT ou MD para começar.'
              : 'O admin do tenant ainda não enviou documentos.'
          }
        />
      ) : (
        <KnowledgeTable docs={query.data.items} canAdmin={canAdmin} />
      )}
    </div>
  );
}
